import { render, staticRenderFns } from "./ControlCargueIndex.vue?vue&type=template&id=14252da4&scoped=true"
import script from "./ControlCargueIndex.vue?vue&type=script&lang=js"
export * from "./ControlCargueIndex.vue?vue&type=script&lang=js"
import style0 from "./ControlCargueIndex.vue?vue&type=style&index=0&id=14252da4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14252da4",
  null
  
)

export default component.exports